/**
 * withIncludeTest — appends `includeTest: 'true'` to query-param objects
 * when the global "Show test data" admin toggle is on.
 *
 * Design note: API modules are plain TypeScript, not React components, so
 * they cannot call hooks.  Reading the flag directly from localStorage
 * (same key the ShowTestDataContext writes) avoids prop-drilling and keeps
 * call sites simple.  The context is the authoritative write path; this
 * helper is the read path.  Both share the same constant key so there is
 * a single source of truth.
 *
 * When the flag is off (or the user is not an admin) the backend silently
 * ignores any stray `includeTest` param, so non-admin usage is safe — but
 * we only ever set it when the flag is genuinely on.
 */

import { SHOW_TEST_DATA_LS_KEY } from '@/contexts/ShowTestDataContext'

export function withIncludeTest<T extends object>(
  params: T
): T | (T & { includeTest: string }) {
  if (localStorage.getItem(SHOW_TEST_DATA_LS_KEY) === 'true') {
    return { ...params, includeTest: 'true' }
  }
  return params
}
